/* ============================================================
   Virelix — global.js
   ============================================================ */
(function () {
  'use strict';

  var routes = window.VirelixRoutes || {};
  var settings = window.VirelixSettings || {};

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = settings.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withThousands)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  /* ---------- Drawers ---------- */
  var overlay = qs('[data-drawer-overlay]');

  function openDrawer(name) {
    closeDrawers();
    var drawer = qs('[data-drawer="' + name + '"]');
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) { overlay.removeAttribute('hidden'); requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    });
    document.body.style.overflow = 'hidden';
    var input = drawer.querySelector('[data-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 250);
  }

  function closeDrawers() {
    qsa('[data-drawer].is-open').forEach(function (drawer) {
      drawer.classList.remove('is-open');
      setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', ''); }, 400);
    });
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { if (!overlay.classList.contains('is-visible')) overlay.setAttribute('hidden', ''); }, 350);
    }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }
    if (e.target === overlay) { closeDrawers(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeModals(); }
  });

  /* ---------- Modals ---------- */
  function openModal(name) {
    var modal = qs('[data-modal="' + name + '"]');
    if (!modal) return;
    modal.removeAttribute('hidden');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeModals() {
    qsa('[data-modal].is-open').forEach(function (modal) {
      modal.classList.remove('is-open');
      setTimeout(function () { if (!modal.classList.contains('is-open')) modal.setAttribute('hidden', ''); }, 300);
    });
    if (!qs('[data-drawer].is-open')) document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) { e.preventDefault(); openModal(opener.getAttribute('data-modal-open')); return; }
    if (e.target.closest('[data-modal-close]')) { e.preventDefault(); closeModals(); }
  });

  /* ---------- Sticky header ---------- */
  var header = qs('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement bar rotation ---------- */
  var bar = qs('[data-announcement-bar]');
  if (bar) {
    var messages = qsa('.announcement-bar__message', bar);
    var current = 0;
    var timer = null;

    var show = function (index) {
      messages[current].classList.remove('is-active');
      current = (index + messages.length) % messages.length;
      messages[current].classList.add('is-active');
    };
    var startTimer = function () {
      if (bar.getAttribute('data-rotate') === 'true' && messages.length > 1) {
        clearInterval(timer);
        timer = setInterval(function () { show(current + 1); }, parseInt(bar.getAttribute('data-interval'), 10) || 5000);
      }
    };
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-announcement-prev]')) { show(current - 1); startTimer(); }
      if (e.target.closest('[data-announcement-next]')) { show(current + 1); startTimer(); }
    });
    startTimer();
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    qsa('[data-reveal]').forEach(function (el) { revealObserver.observe(el); });
  } else {
    qsa('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /* ---------- Cart ---------- */
  function updateCartCount() {
    fetch(routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  function refreshCartDrawer(open) {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-drawer="cart"]');
        var existing = qs('[data-drawer="cart"]');
        if (fresh && existing) {
          var wasOpen = existing.classList.contains('is-open');
          existing.innerHTML = fresh.innerHTML;
          if (open && !wasOpen) openDrawer('cart');
        }
        updateCartCount();
      })
      .catch(function () { updateCartCount(); });
  }

  function addToCart(variantId, quantity, button) {
    if (button) setLoading(button, true);
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (data) { throw data; });
        return r.json();
      })
      .then(function () {
        return refreshCartDrawer(true);
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to bag. Please try again.';
        alertInline(button, msg);
      })
      .then(function () { if (button) setLoading(button, false); });
  }

  function setLoading(button, loading) {
    var spinner = button.querySelector('.quick-add__spinner');
    var label = button.querySelector('.quick-add__label') || button.querySelector('[data-atc-text]');
    if (spinner) spinner.hidden = !loading;
    if (label) label.style.opacity = loading ? '0.4' : '';
    button.disabled = loading;
  }

  function alertInline(button, msg) {
    if (!button) return;
    var label = button.querySelector('.quick-add__label') || button.querySelector('[data-atc-text]');
    if (!label) return;
    var original = label.textContent;
    label.textContent = msg.length > 40 ? 'Unavailable' : msg;
    setTimeout(function () { label.textContent = original; }, 2500);
  }

  function changeCartLine(line, quantity) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      } else {
        return refreshCartDrawer(false);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var quickAdd = e.target.closest('[data-quick-add-single]');
    if (quickAdd) {
      e.preventDefault();
      addToCart(quickAdd.getAttribute('data-variant-id'), 1, quickAdd);
      return;
    }

    var quickShopToggle = e.target.closest('[data-quick-shop-toggle]');
    if (quickShopToggle) {
      e.preventDefault();
      var panel = quickShopToggle.parentElement.querySelector('.quick-shop__panel');
      if (panel) {
        var isHidden = panel.hidden;
        qsa('.quick-shop__panel').forEach(function (p) { p.hidden = true; });
        panel.hidden = !isHidden;
        quickShopToggle.setAttribute('aria-expanded', String(isHidden));
      }
      return;
    }
    if (!e.target.closest('[data-quick-shop]')) {
      qsa('.quick-shop__panel').forEach(function (p) { p.hidden = true; });
    }

    var qtyChange = e.target.closest('[data-cart-qty-change]');
    if (qtyChange) {
      e.preventDefault();
      var line = qtyChange.getAttribute('data-line-index');
      var input = qs('[data-line-index="' + line + '"].qty__input') ||
        (qtyChange.parentElement ? qtyChange.parentElement.querySelector('.qty__input') : null);
      var currentQty = input ? parseInt(input.value, 10) : 1;
      var next = currentQty + parseInt(qtyChange.getAttribute('data-cart-qty-change'), 10);
      changeCartLine(line, Math.max(0, next));
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeCartLine(removeBtn.getAttribute('data-line-index'), 0);
      return;
    }

    var confirmDelete = e.target.closest('[data-confirm-delete]');
    if (confirmDelete) {
      if (!window.confirm('Delete this address?')) e.preventDefault();
    }
  });

  /* ---------- Product page ---------- */
  var productPage = qs('[data-product-page]');
  if (productPage) {
    var productJsonEl = qs('[data-product-json]', productPage);
    var productData = null;
    try { productData = JSON.parse(productJsonEl.textContent); } catch (err) { productData = null; }

    var form = qs('[data-product-form]', productPage) || qs('#ProductForm', productPage) || qs('.product-form', productPage);
    var variantInput = qs('[data-variant-id-input]', productPage);
    var atcButton = qs('[data-add-to-cart]', productPage);
    var qtyInput = qs('[data-qty-input]', productPage);

    /* Quantity buttons */
    productPage.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-minus]') && qtyInput) {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      }
      if (e.target.closest('[data-qty-plus]') && qtyInput) {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      }
    });

    /* Variant selection */
    function selectedOptions() {
      var opts = [];
      qsa('.variant-picker__group', productPage).forEach(function (group) {
        var checked = group.querySelector('input[data-option-value]:checked');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      if (!productData) return null;
      return productData.variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === opts[index]; });
      });
    }

    function updateVariantUI(variant) {
      var priceEl = qs('.product-info__price [data-price]', productPage);
      var compareEl = qs('.product-info__price [data-compare-price]', productPage);
      var stickyPrice = qs('[data-sticky-price]', productPage);
      var stickyAdd = qs('[data-sticky-add]', productPage);

      if (!variant) {
        if (atcButton) {
          atcButton.disabled = true;
          var textEl = qs('[data-atc-text]', atcButton);
          if (textEl) textEl.textContent = 'Unavailable';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.classList.toggle('price__current--sale', variant.compare_at_price > variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareEl.hidden = true;
        }
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (atcButton) {
        atcButton.disabled = !variant.available;
        var atcText = qs('[data-atc-text]', atcButton);
        if (atcText) atcText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        stickyAdd.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }

      /* Slide gallery to variant image */
      if (variant.featured_media && variant.featured_media.id) {
        var slide = qs('[data-media-id="' + variant.featured_media.id + '"]', productPage);
        if (slide) activateSlide(parseInt(slide.getAttribute('data-media-index'), 10));
      }

      /* Update URL */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    productPage.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-option-value]')) return;
      var group = e.target.closest('.variant-picker__group');
      if (group) {
        var label = group.querySelector('[data-selected-value]');
        if (label) label.textContent = e.target.value;
      }
      updateVariantUI(findVariant(selectedOptions()));
    });

    /* AJAX add to cart from product form */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = variantInput ? variantInput.value : null;
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (variantId) addToCart(variantId, quantity, atcButton);
      });
    }

    /* Gallery */
    var slides = qsa('.product-gallery__slide', productPage);
    var thumbs = qsa('.product-gallery__thumb', productPage);
    var mainTrack = qs('[data-gallery-main]', productPage);

    function activateSlide(index) {
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
      if (window.innerWidth < 990 && mainTrack && slides[index]) {
        mainTrack.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateSlide(parseInt(thumb.getAttribute('data-thumb-index'), 10));
      });
    });

    if (mainTrack) {
      var scrollTimeout;
      mainTrack.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          if (window.innerWidth >= 990) return;
          var index = Math.round(mainTrack.scrollLeft / mainTrack.offsetWidth);
          thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === index); });
        }, 80);
      }, { passive: true });
    }

    /* Zoom */
    productPage.addEventListener('click', function (e) {
      var zoomBtn = e.target.closest('[data-gallery-zoom]');
      if (!zoomBtn) return;
      var slide = zoomBtn.closest('.product-gallery__slide');
      var img = slide ? slide.querySelector('img[data-zoom-src]') : null;
      var target = qs('[data-zoom-image]', productPage);
      if (img && target) {
        target.src = img.getAttribute('data-zoom-src');
        openModal('gallery-zoom');
      }
    });

    /* Sticky ATC */
    var stickyBar = qs('[data-sticky-atc]', productPage);
    if (stickyBar && atcButton && 'IntersectionObserver' in window) {
      stickyBar.removeAttribute('hidden');
      stickyBar.classList.remove('is-visible');
      var atcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      atcObserver.observe(atcButton);

      var stickyAddBtn = qs('[data-sticky-add]', stickyBar);
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function () {
          var variantId = variantInput ? variantInput.value : null;
          var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
          if (variantId) addToCart(variantId, quantity, atcButton);
        });
      }
    }
  }

  /* ---------- Product recommendations ---------- */
  qsa('[data-recommendations]').forEach(function (sectionEl) {
    var url = sectionEl.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          sectionEl.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  });

  /* ---------- Collection: sort, facets, load more ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort-select]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  var facetsForm = qs('[data-facets-form]');
  if (facetsForm) {
    facetsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();
      qsa('input, select', facetsForm).forEach(function (field) {
        if (!field.name) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        if (field.value === '') return;
        params.append(field.name, field.value);
      });
      window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    });
  }

  document.addEventListener('click', function (e) {
    var loadMore = e.target.closest('[data-load-more]');
    if (!loadMore) return;
    e.preventDefault();
    loadMore.textContent = 'Loading…';
    fetch(loadMore.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newItems = parsed.querySelectorAll('[data-collection-grid] .product-grid__item');
        var grid = qs('[data-collection-grid]');
        var pagination = qs('.pagination');
        if (grid) {
          newItems.forEach(function (item) { grid.appendChild(item); });
        }
        var newPagination = parsed.querySelector('.pagination');
        if (pagination) {
          if (newPagination) { pagination.replaceWith(newPagination); }
          else { pagination.remove(); }
        }
      })
      .catch(function () { window.location.href = loadMore.href; });
  });

  /* ---------- Login / recover toggle ---------- */
  var loginWrap = qs('[data-login-wrap]');
  if (loginWrap) {
    var loginForm = qs('[data-login-form]', loginWrap);
    var recoverForm = qs('[data-recover-form]', loginWrap);
    loginWrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-show-recover]')) { loginForm.hidden = true; recoverForm.hidden = false; }
      if (e.target.closest('[data-show-login]')) { loginForm.hidden = false; recoverForm.hidden = true; }
    });
    if (window.location.hash === '#recover' && recoverForm) { loginForm.hidden = true; recoverForm.hidden = false; }
  }

  /* ---------- Addresses ---------- */
  var addressSection = qs('[data-addresses]');
  if (addressSection) {
    addressSection.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-address-toggle]');
      if (!toggle) return;
      var target = document.getElementById(toggle.getAttribute('data-address-toggle'));
      if (target) target.hidden = !target.hidden;
    });

    qsa('[data-address-country]', addressSection).forEach(function (countrySelect) {
      var wrapper = countrySelect.closest('.form-grid') || addressSection;
      var provinceSelect = wrapper.querySelector('[data-address-province]');
      var provinceWrapper = wrapper.querySelector('[data-province-wrapper]');

      function updateProvinces() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var raw = option ? option.getAttribute('data-provinces') : null;
        var provinces = [];
        try { provinces = JSON.parse(raw || '[]'); } catch (err) { provinces = []; }
        if (!provinceSelect || !provinceWrapper) return;
        provinceSelect.innerHTML = '';
        if (provinces.length === 0) {
          provinceWrapper.hidden = true;
          return;
        }
        provinces.forEach(function (province) {
          var opt = document.createElement('option');
          opt.value = province[0];
          opt.textContent = province[1];
          provinceSelect.appendChild(opt);
        });
        var def = provinceSelect.getAttribute('data-default');
        if (def) provinceSelect.value = def;
        provinceWrapper.hidden = false;
      }

      var defaultCountry = countrySelect.getAttribute('data-default');
      if (defaultCountry) countrySelect.value = defaultCountry;
      countrySelect.addEventListener('change', updateProvinces);
      updateProvinces();
    });
  }

  /* ---------- Initialize cart count on load ---------- */
  updateCartCount();
})();
